import { Stack, Typography, useTheme } from "@mui/material";
import { ChartNoAxesColumn } from "lucide-react";
import { useTranslation } from "react-i18next";

type IComplexityLevel = {
        complexity: "BASE" | "MEDIUM" | "ADVANCED"
    }

export const ComplexityLevel =(
  { 
    complexity 
  }: IComplexityLevel)=> {
  const { t } = useTranslation();
  const { customColors } = useTheme();
  const { exploreCardText } = customColors;
  return (
    <Stack flexDirection="row" gap="0.25rem" alignItems="center" marginBottom={ "1rem" } >
      <ChartNoAxesColumn size="0.75rem" />
      <Typography color={ exploreCardText } fontSize="0.8rem" >
        { t("level_" + complexity) }
      </Typography>
    </Stack>
  );
};
